export default __webpack_public_path__ + "static/media/80.a48907ef.jpg";